<template>
	<div class="main" v-loading="list_loading">
		<el-row class="add-btn"><el-button type="primary" style="margin-right:40px;" @click="add_oper = true">添加</el-button></el-row>
		<el-table :data="dataList" border style="width: 100%">
			<el-table-column prop="id" label="id"></el-table-column>
			<el-table-column label="发布时间">
				<template scope="scope">
					<span>{{ scope.row.updateTime | formatDate }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="title" label="模板名称"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="success" @click="handleAdmin(scope.row)" icon="el-icon-view">详情</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				background
				@size-change="handleSizeChange"
				:page-sizes="[5, 10, 20]"
				:page-size="pageSize"
				layout="sizes,prev, pager, next,total,jumper"
				:total="total"
			></el-pagination>
		</div>
		<!-- 添加 -->
		<el-dialog :visible.sync="add_oper" width="70%" top="8vh">
			<!-- 模板名称：input框 -->
			<add-operation></add-operation>
		</el-dialog>
		<!-- 管理 -->
		<el-dialog :visible.sync="admin_dv" width="70%" top="8vh">
			<!-- 模板名称：input框 -->
			<admin-operation :adminData="adminData"></admin-operation>
		</el-dialog>
	</div>
</template>

<script>
import addOperation from './add_operation.vue';
import adminOperation from './admin_operation.vue';
export default {
	components: {
		addOperation,
		adminOperation
	},
	data() {
		return {
			total: 0, //总页数
			pageSize: 10, //每页条数
			// pageNum:1,
			currentPage: 1, //当前页（默认第一页）
			dataList: [],
			name: '',
			idcardno: '',
			mobile: '',
			add_oper: false,
			admin_dv: false,
			detail_dv: false,
			detail_loading: false,
			dialogUserInfo: [],
			handle: false,
			action: '',
			list_loading: false,
			adminData: []
		};
	},
	created() {
		this.getList();
	},
	mounted() {
		//判断子组件传的数（弹框关闭）
		this.$bus.$on('isAdd', val => {
			this.add_oper = val;
			this.admin_dv = val;
			this.getList();
		});
	},
	//时间戳的处理
	filters: {
		formatDate: function(value) {
			var date = new Date(value); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
			var Y = date.getFullYear() + '-';
			var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
			var D = (date.getDate() + 1 < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
			var h = (date.getHours() + 1 < 10 ? '0' + date.getHours() : date.getHours()) + ':';
			var m = (date.getMinutes() + 1 < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
			var s = (date.getSeconds() + 1 < 10 ? '0' + date.getSeconds() : date.getSeconds()) ;
			// var s = date.getSeconds();
			return Y + M + D + h + m + s;
			
		}
	},
	methods: {
		handleCurrentChange(val) {
			this.currentPage = val; //获取当前页
			this.getList();
		},
		handleSizeChange(psize) {
			//选择每页条数
			this.pageSize = psize;
			this.getList();
		},

		//获取列表
		getList() {
			let data = new FormData();
			data.append('length', this.pageSize);
			data.append('page', this.currentPage);
			// data.append('pageSize', this.pageSize);
			// data.append('pageNum', this.pageNum);
			this.$post('api/form/listData', data)
				.then(res => {
					// window.console.log(res);
					this.dataList = res.data.list;
					this.total = res.data.total;
					this.list_loading = false;
				})
				.catch(e => {
					window.console.log(e);
				});
		},

		handleAdmin(row) {
			this.admin_dv = true;
			// window.console.log(row);
			let data = new FormData();
			data.append('id', row.id);

			this.$post('api/form/loadFormData', data)
				.then(res => {
					this.adminData = res.data;
				})
				.catch(e => {
					window.console.log(e);
				});
		},
		handleDelete(row) {
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post('api/form/' + row.id + '/delete')
					.then(res => {
						// let totalPage = Math.ceil((this.total - 1) / this.pageSize);
						// let currentPage = this.currentPage > totalPage ? totalPage : this.currentPage;
						// this.currentPage = currentPage < 1 ? 1 : currentPage;

						var isSuccess = res.success;
						if (isSuccess == 1) {
							this.$message({
								type: 'success',
								message: res.message
							});
							const totalPage = Math.ceil((this.count - 1) / this.pageSize); // 总页数
							this.currentPage = this.currentPage > totalPage ? totalPage : this.currentPage;
							this.currentPage = this.currentPage < 1 ? 1 : this.currentPage;
							this.getList();
						}
					})
					.catch(e => {
						window.console.log(e);
					});
			});
		}
	}
};
</script>

<style scoped="scoped">
.main .block {
	text-align: center;
	margin-top: 20px;
}

.main {
	background: #fff;
	padding: 0 20px 20px 20px;
}
.add-btn {
	padding-top: 20px;
	margin-bottom: 20px;
}

.add-btn .el-button {
	font-size: 16px;
}
.searchConent {
	padding-top: 20px;
}
.searchConent .el-row .el-col:first-of-type {
	border-right: 1px solid #eee;
}
.searchConent .el-row:first-of-type {
	display: flex;
	border: 1px solid #eee;
}
.searchConent .el-row:nth-of-type(2) {
	border-left: 1px solid #eee;
	border-bottom: 1px solid #eee;
	border-right: 1px solid #eee;
}
.searchConent .el-col:nth-of-type(3) {
	border-left: 1px solid #eee;
	border-right: 1px solid #eee;
}
.searchConent .el-col {
	height: 50px;
	padding: 5px;
	line-height: 38px !important;
	color: #606266;
	font-size: 14px;
}
.searchConent .el-col:first-of-type,
.searchConent .el-col:nth-of-type(3) {
	text-align: center;
}
.searchConent {
	margin-bottom: 20px;
}
.searchConent .search {
	text-align: right;
	margin-top: 20px;
}

/* .el-table td,
.el-table th {
	text-align: center;
} */
.searchConent .el-select {
	width: 100%;
}
</style>
